export const UserType = {
  admin: 1,
  tenant: 2,
} as const;

export type UserTypeValue = (typeof UserType)[keyof typeof UserType];
